// https://fubotv.atlassian.net/wiki/spaces/PLAT/pages/1969160193/Error+Handling
import { UPApiError } from '../../errors.js';
export function normalizeUPApiError(res) {
    if (res instanceof UPApiError)
        return res;
    if (typeof res === 'string')
        return new UPApiError(400, res, {}, 'Bad Request');
    const response = res?.response || res;
    const body = response?.body;
    const status = response?.status;
    const statusCode = status ? Number(status) : 400;
    const message = body?.message || response?.message || 'Unknown Error';
    const values = body?.values || {};
    const code = body?.code ?? '';
    return new UPApiError(statusCode, message, values, code);
}
